/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_service_1 = require("./configuration.service");
/**
 * @hidden
 */
var CollectionComponent = /** @class */ (function () {
    function CollectionComponent(configKey, configurationService, collectionService) {
        var _this = this;
        this.configKey = configKey;
        this.configurationService = configurationService;
        this.collectionService = collectionService;
        this.items = [];
        this.subscription = collectionService.onItemChange$.subscribe(function (changes) { return _this.processChanges(changes); });
    }
    CollectionComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    CollectionComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.readItems();
        this.children.changes.subscribe(function () { return _this.readItems(); });
    };
    CollectionComponent.prototype.processChanges = function (changes) {
        if (!this.children) {
            return;
        }
        var index = this.children.toArray().indexOf(changes.sender);
        if (index < 0) {
            return;
        }
        this.items[index] = changes.options;
        this.change();
    };
    CollectionComponent.prototype.readItems = function () {
        this.items = this.children.map(function (s) { return s.options; });
        this.change();
    };
    CollectionComponent.prototype.change = function () {
        this.configurationService.notify(new configuration_service_1.Change(this.configKey, this.items.length === 0 ? undefined : this.items));
    };
    return CollectionComponent;
}());
exports.CollectionComponent = CollectionComponent;
